import Api from "../config/api";

export const findAllExameDasa = async (variables) => {
  const response = await Api.post("", {
    query: `query FindAllExameDasa($sujeitoAtencao: SujeitoAtencaoInput, $profissionalSaude: ProfissionalSaudeInput, $pageable: PageableDTOInput, $solicitacaoDasa: SolicitacaoDasaInput) {
  findAllExameDasa(sujeitoAtencao: $sujeitoAtencao, profissionalSaude: $profissionalSaude, pageable: $pageable, solicitacaoDasa: $solicitacaoDasa) {
    content {
      dataCriacao
      codigo
      id
      profissionalSaude {
        id
        nome
      }
      solicitacoesDasa {
        id
        exameDasa {
          id
          codigo
        }
        informacao
        dataCriacao
        resultadoDasa {
          origem
          dataHora
          id
        }
          status
        idAlvaro
         amostrasDasa {
          descricao
          id
          descricaoMaterial
          descricaoAcondicionamento
          codigoBarras
          idAcondicionamento
          idAmostra
          idAmostraExecutor
          idDestino
          identificacao
          lote
          material
          mnemonico
          volume
          pedidosDasa {
            exame
            dadosAdicionais
            amostraDasa {
              descricao
              descricaoMaterial
              descricaoAcondicionamento
            }
          }
        }
      }
      sujeitoAtencao {
        id
        nome
      }
    }
      last
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findAllExameDasa;
};

export const findResultadoDasaHowPDFByExameDasaId = async (variables) => {
  const response = await Api.post("", {
    query: `query findResultadoDasaHowPDFByExameDasaId($assinatura: Boolean, $entidadeId: String, $logo: Boolean, $ordemServico: String, $exames: [String]) {
  findResultadoDasaHowPDFByExameDasaId(assinatura: $assinatura, entidadeId: $entidadeId, logo: $logo, ordemServico: $ordemServico, exames: $exames)
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findResultadoDasaHowPDFByExameDasaId;
};

export const findAllMateriaisExames = async (variables) => {
  const response = await Api.post("", {
    query: `query FindMateriais($exame: String) {
        findMateriais(exame: $exame) {
        codigo
        descricao
      }
    }`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findMateriais;
};

export const createExameDasa = async (variables) => {
  const response = await Api.post("", {
    query: `mutation CreateExameDasa($agendamentoProcedimentoId: UUID, $sujeitoAtencao: SujeitoAtencaoInput, $pedidoSolicitacoes: [SolicitacaoInput], $profissionalSolicitanteId: Long, $exameSolicitado: ExameDasaTipoInput) {
  createExameDasa(agendamentoProcedimentoId: $agendamentoProcedimentoId, sujeitoAtencao: $sujeitoAtencao, pedidoSolicitacoes: $pedidoSolicitacoes, profissionalSolicitanteId: $profissionalSolicitanteId, exameSolicitado: $exameSolicitado) {
    id
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.createExameDasa;
};

export const findAllExameDasaTipo = async (variables) => {
  const response = await Api.post("", {
    query: `query FindAllExameDasaTipo($search: String, $pageableDto: PageableDTOInput) {
  findAllExameDasaTipo(search: $search, pageableDTO: $pageableDto) {
    content {
      codigo
      descricao
      acondicionamento
      id
      prazo
      quantidadeAmostras
      volumeMinimo
      tipo
    }
    last
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response;
};

export const findAllProcedimentosByExameDasaId = async (variables) => {
  const response = await Api.post("", {
    query: `query($exameId: UUID) {
      findAllProcedimentosByExameDasaTipo(exameId: $exameId) {
        nome
        id
      }
    }`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findAllProcedimentosByExameDasaTipo;
}

export const atualizarProcedimentosExame = async (variables) => {
  const response = await Api.post("", {
    query: `mutation ($exameId: UUID, $procedimentos: [ProcedimentoInput]) {
  atualizarProcedimentosExame(exameId: $exameId, procedimentos: $procedimentos) {
    id
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.atualizarProcedimentosExame;
}

export const findAllProcedimentosComExame = async (variables) => {
  const response = await Api.post("", {
    query: `query ($procedimentos: [ProcedimentoInput]) {
  findAllProcedimentosComExame(procedimentos: $procedimentos) {
    id
    nome
    exameDasaTipo {
      id
      descricao
    }
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findAllProcedimentosComExame;
}

export const findAllExamesDasaTipoByProcedimentos = async (variables) => {
  const response = await Api.post("", {
    query: `query FindAllExamesDasaTipoByProcedimentos($procedimentos: [ProcedimentoInput]) {
  findAllExamesDasaTipoByProcedimentos(procedimentos: $procedimentos) {
    id
    descricao
    
    procedimentos {
      nome
      id
    }
    tipo
    volumeMinimo
    quantidadeAmostras
    prazo
    codigo
    acondicionamento
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findAllExamesDasaTipoByProcedimentos;
}

export const findAllProcedimentosDasa = async (variables) => {
  const response = await Api.post("", {
    query: `query($agendamentoId: Long) {
  findProcedimentosDasaByAgendamento(agendamentoId: $agendamentoId) {
    procedimentoId
    exameDasaTipo {
      prazo
      id
      descricao
      quantidadeAmostras
      volumeMinimo
      codigo
      acondicionamento
      tipo
    }
    nomeProcedimento
    agendamentoProcedimentoId
    incluido
  }
}`,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message);
  }
  return response.data.data.findProcedimentosDasaByAgendamento;
}